import styled from "styled-components";

export const ClassJoinModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ClassJoinModalHeading = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
  margin: 0 0 8px 0;
`;

export const ClassJoinModalDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  line-height: 1.3;
  margin: 0 0 8px 0;
`;

export const ClassJoinModalImageWrapper = styled.figure`
  margin: 0 0 30px 0;
  position: relative;
`;
